module.exports = __webpack_public_path__ + "static/media/award.bd95f3d0.svg";